<ng-container [formGroup]="formGroup">
    <!-- I utskrift -->
    <td class="pristabell-w-xl">
        <div class="d-flex align-items-center pristabell-checkbox">
            <rask-checkbox
                formControlName="visasIUtskrift">
            </rask-checkbox>
            <div class=" d-flex flex-column">
                <span class="fw-bold">{{prisRad().handelssortimentsgruppNamn}}</span>
                <span class="handelssortiment-namn">{{prisRad().handelssortimentNamn}}</span>
            </div>
            @if (prisRad().hasHeaderOptions) {
            <div ngbDropdown
                dropdownClass="pristabellDropdown"
                container="body"
                class="ms-auto">
                <rask-icon-button ngbDropdownToggle
                    icon="far fa-ellipsis-vertical">
                </rask-icon-button>
                <div ngbDropdownMenu>
                    @for (option of prisRad().headerOptions; track $index) {
                    <rask-action-button
                        (mousedown)="onRowAction(option.action)">
                        {{ option.text }}
                    </rask-action-button>
                    }
                </div>
            </div>
            }
        </div>
    </td>

    <!-- Måttslag -->
    <td class="pristabell-w-s">
        @if (!prisRad().autokompletterad) {
        <rask-selector
            [portalToBody]="true"
            [values]="mattslagOptions$"
            [canDelete]="false"
            formControlName="mattslag">
        </rask-selector>
        }
    </td>

    <!-- Välj (prisberäkningstyp) -->
    @if (!isU6) {
    <td class="pristabell-w-m">
        @if (!prisRad().autokompletterad) {
        <rask-selector
            [portalToBody]="true"
            [values]="prisberakningOptions"
            [viewFormatter]="priseberakningViewFormatter"
            (change)="prisberakningChanged($event)"
            [canDelete]="false"
            formControlName="prisberakning">
        </rask-selector>
        }
    </td>
    }

    <!-- Prislista -->
    @if (!isU6) {
    <td class="pristabell-w-m">
        @if (prislistaOptions$ | async; as prislistaOptions) {
        @if (prisRad().hasPrislista) {
        <rask-selector
            [portalToBody]="true"
            [formControl]="$any(formGroup.controls.marknadsprislistaId)"
            [values]="prislistaOptions"
            bindValue="id"
            placeholder="Välj"
            (change)="prislistaChanged($event)"
            [viewFormatter]="marknadsprislistaViewFormatter">
        </rask-selector>
        }
        }
    </td>
    }

    <!-- Sortimentsnetto -->
    <td class="pristabell-w-s">
        @if (prisRad().isSortimentsnetto) {
        <rask-input
            [inputProcessor]="numberProcessor"
            formControlName="sortimentsnetto">
        </rask-input>
        }
    </td>

    <!-- T/A (tilläggAvdrag) -->
    @if (!isU6) {
    <td class="pristabell-w-xs">
        @if (prisRad().hasTillaggAvdrag) {
        <rask-input
            [inputProcessor]="numberProcessor"
            formControlName="tillaggAvdrag">
        </rask-input>
        }
    </td>
    }

    <!-- FSC -->
    <td class="pristabell-w-xs">
        @if (!prisRad().autokompletterad) {
        <rask-input
            [inputProcessor]="numberProcessor"
            formControlName="fsc">
        </rask-input>
        }
    </td>

    <!-- PEFC -->
    <td class="pristabell-w-xs">
        @if (!prisRad().autokompletterad) {
        <rask-input
            [inputProcessor]="numberProcessor"
            formControlName="pefc">
        </rask-input>
        }
    </td>

    <!-- Sortimentskod -->
    @if (viol2) {
    <td class="pristabell-w-m">
        <rask-selector
            [portalToBody]="true"
            [formControl]="$any(formGroup.controls.sortimentId)"
            [values]="prisRad().sortimentLista"
            [canDelete]="false"
            bindLabel="kod"
            bindValue="id">
        </rask-selector>
    </td>
    }

    <!-- Mäts in som -->
    @if (viol3) {
    <td class="pristabell-w-m">
        <span class="inmatningshs">{{prisRad().inmatningshandelssortiment}}</span>
    </td>
    }

    <!-- Anteckning -->
    <td class="pristabell-w-xl">
        @if (!prisRad().autokompletterad) {
        <rask-input
            formControlName="anteckning"
            [maxlength]="20"></rask-input>
        }
    </td>
</ng-container>